import { z } from 'zod'

// ===========================================
// Template Field Definition Schema
// ===========================================

export const templateFieldSchema = z.object({
  key: z.string().min(1, 'La clave del campo es requerida'),
  label: z.string().min(1, 'La etiqueta del campo es requerida'),
  type: z.enum(['text', 'number', 'date', 'select', 'textarea']),
  required: z.boolean().default(false),
  source: z.string().optional(), // Path like 'parties.tenant.firstName'
  sourcePath: z.string().optional(), // Alternative path format
  options: z.array(z.string()).optional(), // For select fields
  default: z.union([z.string(), z.number()]).optional(),
})

export type TemplateField = z.infer<typeof templateFieldSchema>

// ===========================================
// Template Schema
// ===========================================

export const templateTypeSchema = z.enum(['residential', 'commercial'], {
  required_error: 'Tipo de plantilla es requerido',
})

export const templateSchema = z.object({
  name: z.string().min(1, 'Nombre de plantilla es requerido'),
  type: templateTypeSchema,
  region: z.string().min(1, 'Region es requerida'),
  htmlContent: z.string().min(1, 'Contenido HTML es requerido'),
  fields: z.array(templateFieldSchema).default([]),
})

export type TemplateFormData = z.infer<typeof templateSchema>

// ===========================================
// Template Filters Schema
// ===========================================

export const templateFiltersSchema = z.object({
  type: templateTypeSchema.optional(),
  region: z.string().optional(),
  isActive: z.coerce.boolean().optional(),
  search: z.string().optional(),
  page: z.coerce.number().int().positive().default(1),
  limit: z.coerce.number().int().positive().max(100).default(20),
})

export type TemplateFilters = z.infer<typeof templateFiltersSchema>

// ===========================================
// API Response Types
// ===========================================

export interface TemplateResponse {
  id: string
  name: string
  type: string
  region: string
  version: number
  isActive: boolean
  htmlContent: string
  fields: TemplateField[]
  createdAt: string
  updatedAt: string
  updatedBy: string
}
